<div class="edition-feedback-automation">
  <header class="edition-feedback-automation__intro">
    <h2 class="edition-feedback-automation__title">Automação de edição</h2>
    <p class="edition-feedback-automation__subtitle">
      Todo dia 1 do mês às 06h, cria e publica os formulários de edição (M-1), atrelando o produto do catálogo.
    </p>
  </header>

  <div class="edition-feedback-automation__grid">
    <section class="edition-feedback-automation__panel edition-feedback-automation__panel--compact">
      <div class="edition-feedback-automation__card-body">
        <div>
          <h3>Agendamento automático</h3>
          <p>
            {{
              schedulerStatus?.scheduleDescription ||
                'Cloud Scheduler · dia 1 às 06:00 (horário de Brasília)'
            }}
          </p>
          <p class="edition-feedback-automation__job-name" *ngIf="schedulerStatus?.jobName">
            Job: {{ schedulerStatus?.jobName }}
          </p>
        </div>
        <span class="edition-feedback-automation__badge edition-feedback-automation__badge--on">
          GCP
        </span>
      </div>
    </section>

    <section class="edition-feedback-automation__panel edition-feedback-automation__panel--compact">
      <div class="edition-feedback-automation__card-body">
        <div>
          <h3>Execução manual</h3>
          <p>Cria os formulários agora, sem esperar o dia 1.</p>
        </div>
        <button
          pButton
          type="button"
          label="Executar agora"
          icon="pi pi-play"
          class="p-button-success"
          [disabled]="isActionLoading || !provisionAvailable"
          (click)="confirmProvision($event)"
        ></button>
      </div>
    </section>
  </div>

  <section class="edition-feedback-automation__panel">
    <div class="edition-feedback-automation__panel-head">
      <div>
        <h3>Histórico de execuções</h3>
        <p>
          Execuções reais do agendador e do botão Executar agora.
        </p>
      </div>
    </div>

    <form
      class="edition-feedback-automation__filters form-b4a"
      [formGroup]="historyFilterForm"
      (ngSubmit)="applyHistoryFilters()"
    >
      <span class="p-float-label">
        <p-dropdown
          inputId="history-month"
          formControlName="referenceMonth"
          [options]="monthFilterOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          (onChange)="applyHistoryFilters()"
        />
        <label for="history-month">Mês da edição</label>
      </span>

      <span class="p-float-label">
        <p-dropdown
          inputId="history-status"
          formControlName="status"
          [options]="statusFilterOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          (onChange)="applyHistoryFilters()"
        />
        <label for="history-status">Status</label>
      </span>

      <span class="p-float-label">
        <p-dropdown
          inputId="history-origin"
          formControlName="triggeredBy"
          [options]="triggeredByFilterOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          (onChange)="applyHistoryFilters()"
        />
        <label for="history-origin">Origem</label>
      </span>
    </form>

    <app-table
      *ngIf="filteredHistoryRows.length > 0"
      [lazy]="false"
      [elements]="filteredHistoryRows"
      [cols]="historyCols"
      [addButton]="false"
      [exportExcel]="false"
      [exportPdf]="false"
      [showTitle]="false"
      [paginator]="true"
      [defaultRows]="6"
      [rowsPerPageOptions]="[6, 12, 18, 24, 30, 60]"
      modelName="histórico de execuções"
      sortField="executedAtSort"
      [sortOrder]="1"
    />

    <div
      *ngIf="!isHistoryLoading && filteredHistoryRows.length === 0"
      class="edition-feedback-automation__placeholder"
    >
      <i class="pi pi-inbox"></i>
      <div>
        <strong>Nenhum registro</strong>
        <span>Execute a automação ou ajuste os filtros para ver o histórico.</span>
      </div>
    </div>
  </section>
</div>

<p-dialog
  header="Pendências da automação"
  [(visible)]="resultDialogVisible"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '640px' }"
  [breakpoints]="{ '768px': '95vw' }"
>
  <p class="edition-feedback-automation__dialog-summary">{{ lastRunSummary }}</p>
  <p class="edition-feedback-automation__dialog-intro">
    A validação encontrou problemas. Corrija os itens abaixo e execute novamente.
  </p>
  <ul class="edition-feedback-automation__error-list">
    <li *ngFor="let error of lastRunErrors">{{ error }}</li>
  </ul>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Entendi"
      class="p-button-outlined"
      (click)="resultDialogVisible = false"
    ></button>
  </ng-template>
</p-dialog>

<p-confirmPopup></p-confirmPopup>
